<template>
  <div>
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'monev_lap_instrumen_verifikasi_dapodik_smk',
  data: function(){
    return {
      msg : 'lap instrumen verifikasi dapodik SMK'
    }
  }
}
</script>

<style>

</style>
